export default "__VITE_ASSET__CMLNQi6n__"